module.exports = __webpack_public_path__ + "img/banner_logo.0991309e.png";